import { render, staticRenderFns } from "./VendorProfileCalendar.vue?vue&type=template&id=124a74ba&scoped=true"
import script from "./VendorProfileCalendar.vue?vue&type=script&lang=js"
export * from "./VendorProfileCalendar.vue?vue&type=script&lang=js"
import style0 from "./VendorProfileCalendar.vue?vue&type=style&index=0&id=124a74ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a74ba",
  null
  
)

export default component.exports